import { initials } from "@/lib/utils";

export function AvatarPill({
  name,
  size = 32,
  url,
}: {
  name: string | null;
  size?: number;
  url?: string | null;
}) {
  if (url) {
    return (
      <img
        src={url}
        alt={name ?? ""}
        loading="lazy"
        className="rounded-full object-cover border border-border"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      className="inline-flex items-center justify-center rounded-full bg-gold-dim text-gold2 font-bold border border-[rgba(201,168,76,0.3)]"
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.36)),
      }}
    >
      {initials(name)}
    </span>
  );
}
